"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var _clientGraphql = require("@trycourier/client-graphql");

var _transport = require("@trycourier/transport");

var _courierJs = _interopRequireDefault(require("@trycourier/courier-js"));

var useCourierActions = function useCourierActions(state, dispatch) {
  return (0, _react.useMemo)(function () {
    var courierClient = (0, _clientGraphql.createCourierClient)({
      apiUrl: state.apiUrl,
      authorization: state.authorization,
      clientSourceId: state.clientSourceId,
      clientKey: state.clientKey,
      userId: state.userId,
      userSignature: state.userSignature
    });
    var clientKey = state.clientKey; //ensure we always have a clientkey

    if (!clientKey && state.authorization) {
      clientKey = "JWT_AUTH";
    }

    _courierJs["default"].init({
      baseUrl: state.apiUrl,
      authorization: state.authorization,
      clientKey: clientKey,
      userId: state.userId,
      userSignature: state.userSignature
    });

    var brands = (0, _clientGraphql.Brands)({
      client: courierClient
    });
    var events = (0, _clientGraphql.Events)({
      client: courierClient
    });
    return {
      dispatch: dispatch,
      track: function track(event, properties) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _courierJs["default"].track(event, properties);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      identify: function identify(userId, payload) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _courierJs["default"].identify(userId, payload);

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      subscribe: function subscribe(userId, listId) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _courierJs["default"].subscribe(userId, listId);

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },
      unsubscribe: function unsubscribe(userId, listId) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
          return _regenerator["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _courierJs["default"].unsubscribe(userId, listId);

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      },
      init: function () {
        var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(payload) {
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  dispatch({
                    type: "root/INIT",
                    payload: payload
                  });

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function init(_x) {
          return _init.apply(this, arguments);
        }

        return init;
      }(),
      initToast: function initToast(payload) {
        dispatch({
          type: "toast/INIT",
          payload: payload
        });
      },
      initInbox: function initInbox(payload) {
        dispatch({
          type: "inbox/INIT",
          payload: payload
        });
      },
      pageVisible: function pageVisible() {
        dispatch({
          type: "root/PAGE_VISIBLE"
        });
      },
      wsReconnected: function wsReconnected() {
        dispatch({
          type: "root/WS_RECONNECTED"
        });
      },
      getBrand: function getBrand(brandId) {
        dispatch({
          type: "root/GET_BRAND",
          payload: function payload() {
            return brands.getBrand(brandId);
          }
        });
      },
      setBrand: function setBrand(brand) {
        dispatch({
          type: "root/GET_BRAND/DONE",
          payload: brand
        });
      },
      createTrackEvent: function createTrackEvent(trackingId) {
        dispatch({
          type: "CREATE_TRACKING_EVENT",
          payload: function payload() {
            return events.trackEvent(trackingId);
          }
        });
      },
      createBatchTrackEvent: function createBatchTrackEvent(eventType) {
        dispatch({
          type: "CREATE_TRACKING_EVENT_BATCH",
          payload: function payload() {
            return events.trackEventBatch(eventType);
          }
        });
      },
      renewSession: function () {
        var _renewSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(token) {
          return _regenerator["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (state.transport instanceof _transport.CourierTransport) {
                    state.transport.renewSession(token);
                  }

                  dispatch({
                    type: "root/UPDATE_AUTH_TOKEN",
                    payload: token
                  });

                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        function renewSession(_x2) {
          return _renewSession.apply(this, arguments);
        }

        return renewSession;
      }()
    };
  }, [state.apiUrl, state.authorization, state.clientKey, state.userId, state.userSignature]);
};

var _default = useCourierActions;
exports["default"] = _default;